import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "../vuex/store";

Vue.use(VueRouter)
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题


const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const routes = [
  //首页
  {path: '/', redirect: '/index', meta: {title: '一站式办公设备共享服务平台-猪小租'}},
  {
    path: '/index',
    name: 'index',
    meta: {title: '一站式办公设备共享服务平台-猪小租'},
    // route level code-splitting
    component: () => import(/* webpackChunkName: "about" */ '../views/index.vue')
  },
  //爆款秒杀
  {
    path: '/explosion',
    name: 'explosion',
    // route level code-splitting
    component: () => import(/* webpackChunkName: "about" */ '../views/explosion.vue')
  },
  //商品列表
  {
    path: '/productList',
    name: 'productList',
    // route level code-splitting
    component: () => import(/* webpackChunkName: "about" */ '../views/productList.vue')
  },
  //商品详情
  {
    path: '/productDetails',
    name: 'productDetails',
    // route level code-splitting
    component: () => import(/* webpackChunkName: "about" */ '../views/productDetails.vue')
  },
  //企业回收
  {
    path: '/enterprise',
    name: 'enterprise',
    // route level code-splitting
    component: () => import(/* webpackChunkName: "about" */ '../views/enterprise.vue')
  },
  //客户说
  {
    path: '/evaluate',
    name: 'evaluate',
    // route level code-splitting
    component: () => import(/* webpackChunkName: "about" */ '../views/evaluate.vue')
  },
  //新闻中心
  {
    path: '/news',
    name: 'news',
    meta: {title: '新闻中心-一站式办公设备共享服务平台-猪小租'},
    // route level code-splitting
    component: () => import(/* webpackChunkName: "about" */ '../views/news.vue')
  },
  //新闻详情
  {
    path: '/newsDetails',
    name: 'newsDetails',
    // route level code-splitting
    component: () => import(/* webpackChunkName: "about" */ '../views/newsDetails.vue')
  },
  //登录页
  {
    path: '/login',
    name: 'login',
    meta: {title: '登录-一站式办公设备共享服务平台-猪小租'},
    // route level code-splitting
    component: () => import(/* webpackChunkName: "about" */ '../views/login.vue')
  },
  //注册页
  {
    path: '/register',
    name: 'register',
    meta: {title: '注册-一站式办公设备共享服务平台-猪小租'},
    // route level code-splitting
    component: () => import(/* webpackChunkName: "about" */ '../views/register.vue')
  },
  //找回密码页
  {
    path: '/forgetPass',
    name: 'forgetPass',
    // route level code-splitting
    component: () => import(/* webpackChunkName: "about" */ '../views/forgetPass.vue')
  },
  //购物车页
  {
    path: '/carts',
    name: 'carts',
    meta: {
      auth: true,
    },
    // route level code-splitting
    component: () => import(/* webpackChunkName: "about" */ '../views/carts.vue')
  },
  //订单页
  {
    path: '/order',
    name: 'order',
    meta: {
      auth: true, //需要登录
      async: true, //是否同步
    },
    // route level code-splitting
    component: () => import(/* webpackChunkName: "about" */ '../views/order.vue')
  },
  //订单支付
  {
    path: '/orderPay',
    name: 'orderPay',
    meta: {
      auth: true,
    },
    // route level code-splitting
    component: () => import(/* webpackChunkName: "about" */ '../views/orderPay.vue')
  },
  //支付成功
  {
    path: '/Pay',
    name: 'Pay',
    meta: {
      auth: true,
    },
    // route level code-splitting
    component: () => import(/* webpackChunkName: "about" */ '../views/Pay.vue')
  },
  //帮助中心
  {
    path: '/helper',
    name: 'helper',
    // route level code-splitting
    component: () => import(/* webpackChunkName: "about" */ '../views/helper.vue')
  },
  //关于我们
  {
    path: '/aboutUs',
    name: 'aboutUs',
    meta: {title: '关于我们-一站式办公设备共享服务平台-猪小租'},
    component: () => import('../views/aboutUs')
  },
  //用户中心
  {
    path: '/ucenter',
    name: 'ucenter',
    meta: {
      auth: true,
    },
    component: () => import('../views/ucenter')
  },
  //用户中心
  {
    path: '/myAddr',
    name: 'myAddr',
    meta: {
      auth: true,
    },
    component: () => import('../views/myAddr')
  },
  //我的订单
  {
    path: '/myOrder',
    name: 'myOrder',
    meta: {
      auth: true,
    },
    component: () => import('../views/myOrder')
  },
  {
    path: '/orderDetails',
    name: 'orderDetails',
    meta: {
      auth: true,
    },
    component: () => import('../views/orderDetails')
  },
   //我的设备
   {
    path: '/myDevice',
    name: 'myDevice',
    meta: {
      auth: true,
    },
    component: () => import('../views/myDevice')
  },
  //我的收藏
  {
    path: '/myFav',
    name: 'myFav',
    meta: {
      auth: true,
    },
    component: () => import('../views/myFav')
  },
  //续约订单
  {
    path: '/rentOrder',
    name: 'rentOrder',
    meta: {
      auth: true,
    },
    component: () => import('../views/rentOrder')
  },
  //我的免押金额度
  {
    path: '/deposit',
    name: 'deposit',
    meta: {
      auth: true,
    },
    component: () => import('../views/deposit')
  },
  //我的发票
  {
    path: '/invoice',
    name: 'invoice',
    meta: {
      auth: true,
    },
    component: () => import('../views/invoice')
  },
  //账户安全
  {
    path: '/account',
    name: 'account',
    meta: {
      auth: true,
    },
    component: () => import('../views/account')
  },
  //退换货
  {
    path: '/recycle',
    name: 'recycle',
    meta: {
      auth: true,
    },
    component: () => import('../views/recycle')
  },
  //实名认证
  {
    path: '/authentication',
    name: 'authentication',
    meta: {
      auth: true,
    },
    component: () => import('../views/authentication')
  },
  //充值
  {
    path: '/recharge',
    name: 'recharge',
    meta: {
      auth: true,
    },
    component: () => import('../views/recharge')
  },
  // //测试特效
  // {
  //   path:'/cs',
  //   name:'cs',
  //   component:()=>import('../views/cs')
  // }
]

const router = new VueRouter({
  mode: 'hash',
  base: '/web/',
  routes,
  scrollBehavior (to, from, savedPosition) { //解决跳转下一个页面底部的方法
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

// 全局路由守卫
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
      document.title = to.meta.title;
  }
  if (to.path == '/login') {
    if (store.isLogin) {
      console.log("is login")
      next({path: '/'})
    } else {
      next()
    }
  } else if (to.meta['auth'] && !store.state.user.isLogin) { // 如果跳转的需要登陆，并且没有登陆
    next({path: '/login', query: {redirect: to.fullPath}})
  } else {
    next()
  }
})


export default router



// WEBPACK FOOTER //
// ./src/router/index.js